import { useEffect, useState } from "react";

export default function useIsIntersecting(ref, delay = 500) {
  const [intersecting, intersectingSet] = useState(false);

  useEffect(() => {
    let intersectionObserver;
    const timer = setTimeout(() => {
      if (!ref.current) return;
      intersectionObserver = new IntersectionObserver(([element]) => {
        intersectingSet(element.isIntersecting);
      });
      intersectionObserver.observe(ref.current);
    }, delay);

    return () => {
      clearTimeout(timer);
      intersectionObserver?.disconnect();
    };
  }, []);

  return intersecting;
}
